<template>
    <div>
        <h4 class="mt-4 mb-1">
            <img
                style="margin: 0 0.5rem 1px 0"
                :src="iconPath + '/flags/' + enquiry.countryCode + '.png'"
                :alt="enquiry.country.name"
                :title="enquiry.country.name"
            />
            <span class="align-middle"
                >{{ __(isOrder ? "Order" : "Enquiry") }}
                {{ isOrder ? enquiry.order.orderID : enquiry.id }}:
                {{ __(fragmentName) }}</span
            >
        </h4>

        <nav class="subnav-container mb-0">
            <ul class="subnav" v-if="!isOrder">
                <li class="subnav-item">{{ formattedDate }}</li>

                <li class="subnav-item">{{ enquiryUserName }}</li>

                <li
                    v-if="
                        enquiry.order &&
                        authed.permissions.includes('full order access')
                    "
                    class="subnav-item"
                >
                    {{ __("Order") }}
                    <a
                        :href="
                            orderRoute.replace('XXXXX', enquiry.order.orderID)
                        "
                        >{{ enquiry.order.orderID }}</a
                    >
                    ({{ __(enquiry.order_status.statusName) }})
                </li>

                <li
                    v-if="
                        enquiry.previous_revision &&
                        enquiry.previous_revision.oldEnquiryID
                    "
                    class="subnav-item"
                >
                    {{ __("Original Enquiry") }}
                    <a
                        :href="
                            enquiryRoute.replace(
                                'XXXXX',
                                enquiry.previous_revision.oldEnquiryID
                            )
                        "
                        >{{ enquiry.previous_revision.oldEnquiryID }}</a
                    >
                </li>

                <li
                    v-if="
                        enquiry.next_revision &&
                        enquiry.next_revision.newEnquiryID
                    "
                    class="subnav-item"
                >
                    {{ __("Revised Enquiry") }}
                    <a
                        :href="
                            enquiryRoute.replace(
                                'XXXXX',
                                enquiry.next_revision.newEnquiryID
                            )
                        "
                        >{{ enquiry.next_revision.newEnquiryID }}</a
                    >
                </li>
            </ul>
            <ul class="subnav" v-else>
                <li class="subnav-item">{{ formattedDate }}</li>

                <li class="subnav-item">{{ enquiryUserName }}</li>

                <li class="subnav-item">
                    {{ __("Enquiry") }}
                    <a :href="enquiryRoute.replace('XXXXX', enquiry.id)">{{
                        enquiry.id
                    }}</a>
                </li>

                <li v-if="enquiry.split_from" class="subnav-item">
                    {{ __("Split from Order") }}
                    <a
                        :href="
                            orderRoute.replace(
                                'XXXXX',
                                enquiry.split_from.previous_order.orderID
                            )
                        "
                        >{{ enquiry.split_from.previous_order.orderID }}</a
                    >
                </li>

                <li v-if="enquiry.split_to.length" class="subnav-item">
                    {{ __("Split into Order(s)") }}
                    <a
                        v-for="split in enquiry.split_to"
                        :key="split.id"
                        :href="
                            orderRoute.replace(
                                'XXXXX',
                                split.next_order.orderID
                            )
                        "
                        class="mr-1"
                        >{{ split.next_order.orderID }}</a
                    >
                </li>
            </ul>
        </nav>

        <div class="row">
            <!-- left nav -->
            <div class="enqNavigation col-xs-12 col-xl-2">
                <enq-portion-progress-status
                    :status="
                        isOrder
                            ? enquiry.orderStatusID
                            : enquiry.enquiryStatusID
                    "
                    :statuses="statuses"
                    :user-id="userId"
                    :is-manager="isManager"
                    :enquiry-user-id="enquiry.user_id"
                    :change-status="changeStatus"
                    :is-order="isOrder"
                    :select-fragment="selectFragment"
                    :country-code="enquiry.countryCode"
                    :override-required="overrideRequired"
                    :overriden="enquiry.overrideMarker"
                ></enq-portion-progress-status>

                <!-- TODO: component -->
                <div class="mainMenu">
                    <a
                        v-for="(data, name) in navigation"
                        :key="data.fragment"
                        class="item"
                        :class="
                            data.divType +
                            (fragment === data.fragment ? ' active' : '')
                        "
                    >
                        <div
                            v-if="'unavailable' !== data.divType"
                            @click="selectFragment(data.fragment)"
                        >
                            <i
                                v-if="'incomplete' === data.divType"
                                class="fas fa-exclamation-circle text-danger"
                            ></i
                            ><i
                                v-else
                                class="fas fa-check-circle text-success"
                            ></i
                            ><span>{{ __(name) }}</span>
                        </div>
                        <div v-else>
                            <i class="fas fa-exclamation-circle"></i
                            ><span>{{ __(name) }}</span>
                        </div>
                    </a>
                </div>

                <!-- TODO: component -->
                <div
                    class="margin"
                    :class="{
                        marginRed: isMarginRed,
                        marginGreen: !isMarginRed,
                    }"
                >
                    {{ __("Profit")
                    }}<!--
                    -->
                    <h2>{{ DEFAULT_CURRENCY_SYMBOL }}{{ formattedProfit }}</h2>
                    <!--
                    -->{{ __("Margin")
                    }}<!--
                    -->
                    <h2>{{ formattedMargin }}&#37;</h2>
                    <!--
                    --><span>{{
                        __(
                            "Final figures may vary due to unforeseen expenses and exchange rate fluctuations."
                        )
                    }}</span>
                </div>

                <!-- not actually buttons lol -->
                <div
                    class="btn btn-danger w-100 mb-3"
                    v-if="
                        !isOrder &&
                        enquiry.enquiryStatusID < 6 &&
                        enquiry.is_blacklisted_account
                    "
                >
                    <span>{{ __("BLACKLISTED ACCOUNT") }}</span>
                </div>

                <div
                    class="btn btn-danger w-100 mb-3"
                    v-if="
                        !isOrder &&
                        enquiry.enquiryStatusID < 6 &&
                        enquiry.is_blacklisted_country
                    "
                >
                    <span>{{ __("BLACKLISTED COUNTRY") }}</span>
                </div>

                <!-- TODO: component -->
                <!-- only a button on thursdays -->
                <div v-if="!isOrder && enquiry.enquiryStatusID < 6">
                    <div
                        v-if="enquiry.overrideMarker"
                        class="btn btn-danger w-100 mb-3"
                    >
                        <span>{{ __("OVERRIDEN") }}</span>
                    </div>

                    <div v-else-if="overrideRequired">
                        <a
                            @click.prevent="managerOverride"
                            v-if="canOverride"
                            :title="overrideRequired"
                            class="btn btn-danger w-100 mb-3"
                            href="#"
                        >
                            <span>{{ __("MANAGER'S OVERRIDE") }}</span>
                        </a>
                        <div
                            v-else
                            :title="overrideRequired"
                            class="btn btn-danger w-100 mb-3"
                        >
                            <span>{{ __("OVERRIDE REQUIRED") }}</span>
                        </div>
                    </div>
                </div>

                <div class="dropDown form-group">
                    <enq-portion-user-allocating
                        class="form-control custom-select"
                        :current-category-id="enquiry.enquiryStatusID"
                        :enquiry-user="enquiry.user_id"
                        :enquiry-id="enquiry.id"
                        :can-unallocate="null === enquiry.order"
                        :users="users"
                        :on-allocated="onAllocated"
                        :return-user="true"
                        :disabled="!isManager && enquiry.user_id !== userId"
                    ></enq-portion-user-allocating>
                </div>

                <a
                    @click.prevent="duplicate"
                    v-if="
                        isManager &&
                        authed.permissions.includes('duplicate enquiries')
                    "
                    class="btn btn-dark w-100 mb-3"
                    href="#"
                >
                    <span>{{ __("DUPLICATE ENQUIRY") }}</span>
                </a>

                <a
                    @click.prevent="recycleModalShown = true"
                    v-if="
                        !isOrder &&
                        !enquiry.quoteMarker &&
                        enquiry.enquiryStatusID < 3 &&
                        (isManager || enquiry.user_id === userId)
                    "
                    class="btn btn-success w-100 mb-3"
                    href="#"
                >
                    <i class="fas fa-recycle mr-2"></i>
                    <span>{{ __("RECYCLE ENQUIRY") }}</span>
                </a>

                <a
                    @click.prevent="markUnread"
                    v-if="
                        !isOrder &&
                        isManager &&
                        enquiry.enquiryStatusID !== 7 &&
                        authed.permissions.includes('full enquiry access')
                    "
                    class="btn btn-success w-100 mb-3"
                    href="#"
                >
                    <span>{{ __("MARK AS UNREAD") }}</span>
                </a>
            </div>
            <!-- /left nav -->
            <!-- fragment -->
            <div class="enqContentContainer col-xs-12 col-xl-7">
                <!-- DETAILS -->
                <div v-if="'details' === fragment">
                    <enq-fragment-details
                        :enquiry="enquiry"
                        :disabled="
                            locked || !authed.permissions.includes('details')
                        "
                        :update-enquiry="updateEnquiry"
                        :is-order="isOrder"
                    ></enq-fragment-details>

                    <enq-portion-uploads
                        :enquiry-id="enquiry.id"
                        :disabled="
                            locked ||
                            enquiry.enquiryStatusID === 7 ||
                            !authed.permissions.includes('uploads')
                        "
                    ></enq-portion-uploads>
                </div>

                <!-- COMPANY -->
                <div v-else-if="'company' === fragment">
                    <enq-fragment-company
                        :enquiry="enquiry"
                        :disabled="
                            locked || !authed.permissions.includes('company')
                        "
                        :icon-path="iconPath"
                        :update-enquiry="updateEnquiry"
                        :is-order="isOrder"
                    ></enq-fragment-company>
                </div>

                <!-- PARTS -->
                <div v-else-if="'parts' === fragment && enquiry.order">
                    <enq-fragment-parts
                        :parts="enquiry.valid_order_parts"
                        :enquiry-id="enquiry.id"
                        :disabled="
                            locked ||
                            !isOrder ||
                            !authed.permissions.includes('parts')
                        "
                        :order="true"
                        :is-order="isOrder"
                        :icon-path="iconPath"
                        :update-enquiry="updateEnquiry"
                        :update-statuses="updateStatuses"
                        :update-stats="updateStats"
                        :currency="enquiry.currency"
                        :exchange-rates="enquiry.exchange_rates"
                        :enquiry-currency-id="enquiry.currency_id"
                        :company-payment-terms-id="companyPaymentTermsId"
                        :valid-pos="enquiry.valid_purchase_orders"
                    ></enq-fragment-parts>
                </div>
                <div v-else-if="'parts' === fragment">
                    <enq-fragment-parts
                        :parts="enquiry.valid_enquiry_parts"
                        :enquiry-id="enquiry.id"
                        :disabled="
                            locked || !authed.permissions.includes('parts')
                        "
                        :order="false"
                        :is-order="isOrder"
                        :icon-path="iconPath"
                        :update-enquiry="updateEnquiry"
                        :update-statuses="updateStatuses"
                        :update-stats="updateStats"
                        :currency="enquiry.currency"
                        :exchange-rates="enquiry.exchange_rates"
                        :enquiry-currency-id="enquiry.currency_id"
                        :company-payment-terms-id="companyPaymentTermsId"
                        :valid-pos="enquiry.valid_purchase_orders"
                        :partFocus="partFocus"
                    ></enq-fragment-parts>
                </div>

                <!-- QUOTATION -->
                <div v-else-if="'quotation' === fragment">
                    <enq-fragment-quotation
                        :enquiry="enquiry"
                        :disabled="
                            locked || !authed.permissions.includes('quotation')
                        "
                        :update-enquiry="updateEnquiry"
                        :update-statuses="updateStatuses"
                    ></enq-fragment-quotation>
                </div>

                <!-- DOCUMENTS -->
                <div v-else-if="'documents' === fragment">
                    <enq-fragment-documents
                        :enquiry="enquiry"
                        :select-fragment="selectFragment"
                        :update-enquiry="updateEnquiry"
                        :disabled="locked"
                    ></enq-fragment-documents>
                </div>

                <!-- INVOICE -->
                <div v-else-if="'invoice' === fragment">
                    <enq-fragment-invoice
                        :enquiry="enquiry"
                        :disabled="
                            locked || !authed.permissions.includes('invoice')
                        "
                        :update-enquiry="updateEnquiry"
                        :update-statuses="updateStatuses"
                    ></enq-fragment-invoice>
                </div>

                <!-- PROFORMA -->
                <div v-else-if="'proforma' === fragment">
                    <enq-fragment-proforma
                        :enquiry="enquiry"
                        :disabled="
                            locked || !authed.permissions.includes('proforma')
                        "
                        :update-enquiry="updateEnquiry"
                    ></enq-fragment-proforma>
                </div>

                <!-- ORDER CONFIRMATION -->
                <div v-else-if="'order-confirmation' === fragment">
                    <enq-fragment-order-confirmation
                        :enquiry="enquiry"
                        :disabled="
                            locked ||
                            !authed.permissions.includes('order-confirmation')
                        "
                        :update-enquiry="updateEnquiry"
                    ></enq-fragment-order-confirmation>
                </div>

                <!-- DELIVERY NOTE -->
                <div v-else-if="'delivery-note' === fragment">
                    <enq-fragment-delivery-note
                        :enquiry="enquiry"
                        :disabled="
                            locked ||
                            !authed.permissions.includes('delivery-note')
                        "
                        :update-enquiry="updateEnquiry"
                    ></enq-fragment-delivery-note>
                </div>

                <!-- PURCHASE ORDERS -->
                <div v-else-if="'purchase-order' === fragment">
                    <enq-fragment-purchase-order
                        :enquiry="enquiry"
                        :disabled="
                            locked ||
                            !authed.permissions.includes('purchase-orders')
                        "
                        :update-enquiry="updateEnquiry"
                        :po="getPO(fragmentData)"
                        :update-stats="updateStats"
                    ></enq-fragment-purchase-order>
                </div>

                <!-- PURCHASE ORDERS -->
                <div v-else-if="'lost' === fragment">
                    <enq-fragment-lost
                        :enquiry="enquiry"
                        :disabled="
                            (locked && enquiry.enquiryStatusID > 5) ||
                            !authed.permissions.includes('lost')
                        "
                        :update-enquiry="updateEnquiry"
                    ></enq-fragment-lost>
                </div>

                <div v-else>{{ __("Unknown fragment?") }}</div>
            </div>
            <!-- /fragment -->
            <!-- notes -->
            <div class="enqNotesContainer col-xs-12 col-xl-3">
                <enq-portion-notes
                    :note-type="'enquiry'"
                    :enquiry-id="enquiry.id"
                    :icon-path="iconPath"
                    :is-manager="isManager"
                ></enq-portion-notes>

                <enq-portion-notes
                    v-if="enquiry.company_contact"
                    :note-type="'company'"
                    :enquiry-id="enquiry.id"
                    :invalidation-id="enquiry.company_contact_id"
                    :icon-path="iconPath"
                    :is-manager="isManager"
                ></enq-portion-notes>
            </div>
            <!-- /notes -->
        </div>

        <!-- Modal -->
        <!-- TODO: component -->
        <transition name="modal" v-if="recycleModalShown">
            <div class="modal-mask">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">
                                {{
                                    __("Are you sure you want to Recycle this?")
                                }}
                            </h5>

                            <button
                                type="button"
                                class="close"
                                @click="recycleModalShown = false"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <!--
                        <div class="modal-body" v-if="modalTax">
                            {{ __('You cannot mark this enquiry as received without a tax code.') }}
                        </div> -->

                        <div class="modal-footer">
                            <button
                                type="button"
                                class="btn btn-primary"
                                @click="recycle"
                            >
                                {{ __("I'm Sure") }}
                            </button>
                            <button
                                type="button"
                                class="btn btn-secondary"
                                @click="recycleModalShown = false"
                            >
                                {{ __("Cancel") }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
const dateFns = require('date-fns');

const { format, parse } = dateFns;

export default {
    name: "EnqView",

    props: {
        iconPath: {
            required: true,
            type: String,
        },
        enquiryRoute: {
            required: true,
            type: String,
        },
        orderRoute: {
            required: true,
            type: String,
        },
        userId: {
            required: true,
            type: Number,
        },
        saleLimit: {
            required: true,
            type: Number,
        },
        isManager: {
            required: true,
            type: Boolean,
        },
        isSuperAdmin: {
            required: true,
            type: Boolean,
        },
        initialEnquiry: {
            required: true,
            type: Object,
        },
        initialFragment: {
            required: false,
            type: String,
        },
        users: {
            required: true,
            type: Array,
        },
        initialStatuses: {
            required: true,
            type: Array,
        },
        isOrder: {
            required: true,
            type: Boolean,
        },
    },

    data() {
        return {
            fragment: this.initialFragment || "details",
            fragmentData: parseInt(window.location.hash.substring(1)),
            enquiry: this.initialEnquiry,
            statuses: this.initialStatuses,
            recycleModalShown: false,
        };
    },

    computed: {
        canOverride() {
            let normal =
                this.isManager &&
                this.authed.permissions.includes("override enquiries") &&
                this.enquiry.user_id !== this.userId;

            return normal || this.isSuperAdmin;
        },

        locked() {
            if (this.isOrder) {
                return this.enquiry.orderStatusID === 13;
            } else {
                return (
                    2 !== this.enquiry.enquiryStatusID ||
                    (!this.isManager && this.enquiry.user_id !== authed.id)
                );
            }
        },

        companyPaymentTermsId() {
            return this.enquiry.company_contact
                ? this.enquiry.company_contact.branch.paymentTermsID
                : 0;
        },

        fragmentName() {
            return (
                this.fragment.charAt(0).toUpperCase() + this.fragment.slice(1)
            ).replace(/(-[a-z])/, function (char) {
                return " " + char.slice(1).toUpperCase();
            });
        },

        formattedDate() {
            let d = this.enquiry.dateReceived;
            if (this.enquiry.order) {
                d = this.enquiry.dateWon;
            }

            const p =parse(d, "yyyy-MM-dd HH:mm:ss", new Date());

            return p.toLocaleDateString() + ' @ ' + format(p, 'HH:mm:ss');
        },

        enquiryUserName() {
            return !this.enquiry.user
                ? __("Unallocated")
                : this.enquiry.user.full_name;
        },

        navigation() {
            // console.log('recalc nav');

            let output = {};
            let navigation = this.isOrder
                ? {
                      "Order Details": "details",
                      "Company Details": "company",
                      "Part Details": "parts",
                      Documents: "documents",
                  }
                : {
                      "Enquiry Details": "details",
                      "Company Details": "company",
                      "Part Details": "parts",
                      Quotation: "quotation",
                      Chase: "chase",
                  };

            let continueNavigation = this.enquiry.user ? true : false;
            for (var name in navigation) {
                var fragment = navigation[name];
                var divType = this.isOrder ? "complete" : "unavailable";

                if (continueNavigation) {
                    switch (fragment) {
                        // Details: No progression without the referral method ID.
                        case "details":
                            divType = this.enquiry.referral_method_id
                                ? "complete"
                                : "incomplete";
                            break;
                        // Company: No progression without a company contact ID.
                        case "company":
                            divType = (
                                this.isOrder
                                    ? this.enquiry.invoiceAddress !== "" &&
                                      this.enquiry.deliveryAddress !== ""
                                    : this.enquiry.company_contact_id
                            )
                                ? "complete"
                                : "incomplete";
                            break;
                        // Parts: It's best to see the quotePreparedMarker and overrideRequired methods in the enquiry class to understand this.
                        case "parts":
                            divType =
                                this.enquiry.quotePreparedMarker ||
                                this.enquiry.order
                                    ? "complete"
                                    : "incomplete";
                            break;
                        // Quotations: No progression without the quoteMarker.
                        case "quotation":
                            divType = this.enquiry.quoteMarker
                                ? "complete"
                                : "incomplete";
                            break;
                        // Chase: No progression without the chaseCounter.
                        case "chase":
                            divType =
                                this.enquiry.chaseCounter > 0
                                    ? "complete"
                                    : "incomplete";
                            break;
                    }

                    if ("incomplete" === divType) {
                        continueNavigation = false;
                    }
                }

                output[name] = {
                    fragment: fragment,
                    divType: divType,
                };
            }

            // console.log('navigation');
            // console.log(output);

            return output;
        },

        formattedProfit() {
            return number_format(this.enquiry.calculated_stats.profit, 2);
        },

        formattedMargin() {
            return number_format(this.enquiry.calculated_stats.margin, 2);
        },

        isMarginRed() {
            return this.enquiry.calculated_stats.margin < MARGIN_PERCENTAGE;
        },

        overrideRequired() {
            /**
             * If the enquiry status is less than 'quoted', we continue.
             * We do not progress past these statuses in case someone in training mode gets allocated an old enquiry for example.
             * Return true on any of the following rules.
             **/
            if (this.enquiry.enquiryStatusID >= 3) {
                return false;
            }

            // The margin is less than 20%, an override is required.
            if (this.enquiry.calculated_stats.margin < MARGIN_PERCENTAGE) {
                return "Margin Below 20%";
            }

            // The sale value is over predefined unchecked value limit.
            if (this.enquiry.calculated_stats.value > this.saleLimit) {
                return (
                    "Enquiry Value Exceeds " +
                    this.saleLimit +
                    " " +
                    DEFAULT_CURRENCY_CURRENCY
                );
            }

            // The country is blacklisted.
            if (this.enquiry.is_blacklisted_country) {
                // If this is a customer, it does not matter if the country is blacklisted.
                if (
                    this.enquiry.company_contact &&
                    this.enquiry.company_contact.branch.company.customerMarker
                ) {
                    return false;
                }

                return "Blacklisted Country";
            }

            // The company is blacklisted.
            if (this.enquiry.is_blacklisted_company) {
                return "Blacklisted Company";
            }

            // The company is blacklisted.
            if (this.enquiry.user && this.enquiry.user.training_mode) {
                return "Training Mode Enabled";
            }

            return false;
        },
    },

    methods: {
        getPO(poid) {
            let selected_po = null;

            this.enquiry.purchase_orders.forEach((po) => {
                if (po.ID === poid) {
                    selected_po = po;
                }
            });

            // console.log('getting PO for poID', poid, selected_po, this.enquiry.purchase_orders);

            return selected_po;
        },

        post(method, callback, new_status) {
            axios
                .post("/api/enquiries/" + method, {
                    enquiryID: this.enquiry.id,
                    statusID: new_status || null,
                })
                .then((response) => {
                    let data = response.data;
                    if (!data.success) {
                        if (data.errors) {
                            console.log(data.errors);
                        } else {
                            $("#fail-alert")
                                .text(data.message || "Unknown error")
                                .slideDown(500)
                                .delay(8000)
                                .slideUp(500);
                        }
                    } else {
                        if (callback) {
                            callback(data);
                        }
                    }
                })
                .catch((error) => {
                    console.error(error.response);
                    this.updating = false;

                    $("#fail-alert")
                        .text(error.toString() || "Unknown error")
                        .slideDown(500)
                        .delay(8000)
                        .slideUp(500);
                });
        },

        onAllocated(selected_user, new_user) {
            if (0 === selected_user) {
                this.enquiry.enquiryStatusID = 1;
                this.enquiry.user = null;
                this.enquiry.user_id = 0;
            } else {
                if (1 === this.enquiry.enquiryStatusID) {
                    this.enquiry.enquiryStatusID = 2;
                }

                this.enquiry.user = new_user;
                this.enquiry.user_id = selected_user;
            }
        },

        selectFragment(new_fragment, fragment_data) {
            if (this.fragment === new_fragment) {
                return;
            }

            if ("chase" === new_fragment) {
                this.post("chase", (data) => {
                    this.updateEnquiry(data.enquiry);
                    this.updateStatuses(data.statuses);

                    var win = window.open(
                        "mailto:" +
                            encodeURIComponent(data.enquiry.emailAddress) +
                            "?subject=" +
                            data.enquiry.id
                    );

                    // Close if application, don't if gmail eg.
                    try {
                        if (win.location.href === "about:blank") {
                            win.close();
                        }
                    } catch (Error) {}
                });

                return;
            }

            this.fragmentData = fragment_data ? fragment_data : 0;
            this.fragment = new_fragment;

            // TODO: title
            history.replaceState({}, null, new_fragment);
            if (this.fragmentData !== 0) {
                window.location.hash = this.fragmentData;
            }
        },

        changeStatus(new_status) {
            this.post(
                this.isOrder ? "order-status" : "enquiry-status",
                (data) => {
                    this.updateEnquiry(data.enquiry);
                    this.updateStatuses(data.statuses);
                },
                new_status
            );
        },

        managerOverride() {
            this.post("override", (data) => {
                this.updateEnquiry(data.enquiry);
            });
        },

        duplicate() {
            this.post("duplicate", (data) => {
                window.location.href = data.url;
            });
        },

        markUnread() {
            this.post("mark-unread", (data) => {
                // this.updateEnquiry(data.enquiry);
                window.location.href = "/enquiries/list";
            });
        },

        recycle() {
            this.recycleModalShown = false;

            this.post("recycle", (data) => {
                window.location.href = data.url;
            });
        },

        updateEnquiry(enquiry, jumpToLatestPart) {
            this.enquiry = enquiry;

            if (enquiry.company_contact) {
                Vue.set(
                    this.enquiry,
                    "company_contact",
                    enquiry.company_contact
                ); // hack to force rebuild of notes
            }
            this.partFocus = false;
            if (true === jumpToLatestPart) {
                this.partFocus = true;
            }
        },

        updateStatuses(statuses) {
            this.statuses = statuses;
        },

        updateStats(stats) {
            // console.log("rewrtign stats!!1", stats);
            Vue.set(this.enquiry, "calculated_stats", stats);
        },
    },
};
</script>
